import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M931.3 484.2h-382c-5.5 0-10-4.5-10-10v-382c0-15.5-12.5-28-28-28s-28 12.5-28 28v382c0 5.5-4.5 10-10 10h-382c-15.5 0-28 12.5-28 28s12.5 28 28 28h382c5.5 0 10 4.5 10 10v382c0 15.5 12.5 28 28 28s28-12.5 28-28v-382c0-5.5 4.5-10 10-10h382c15.5 0 28-12.5 28-28 0-15.4-12.5-28-28-28z\" fill=\"\" p-id=\"6419\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol